import { FetcherResult } from "../api-client/fetcher";
import { ModifiedSWRResponse, useSwrGet } from "../api-client/useSwrGet";
import { useNullableDealerAccountInfo } from "../stores/hooks/useNullableDealerAccountInfo";
import { OrderDetails } from "../stores/slices/cartSlice";

export const useGetDealerOrder = (
  orderNumber?: null | string
): ModifiedSWRResponse<FetcherResult<Payload>, Payload> => {
  const dealer = useNullableDealerAccountInfo();

  const result = useSwrGet<Payload>(
    orderNumber && dealer
      ? "/retailSiteWebService/shopping/dealerOrder/getDealerOrder.php"
      : null,
    {
      dealerId: dealer?.dealerId ?? "",
      orderNumber: orderNumber ?? "",
    }
  );
  return result;
};

type Payload = OrderDetails;
